import PropTypes from 'prop-types'
import React from 'react'
import TextUser from './TextUser'
import AvatarUser from './AvatarUser'
import ListItemUser from './ListItemUser'
import UserMenu from './UserMenu'

export class User extends React.PureComponent {
  static propTypes = {
    text: PropTypes.bool,
    avatar: PropTypes.bool,
    listItem: PropTypes.bool,
    defaultMenu: PropTypes.bool,
    menu: PropTypes.array,

    // User props
    id: PropTypes.number,
    email: PropTypes.string,
    name: PropTypes.string,
    profileKey: PropTypes.string,
    licenseType: PropTypes.number,
    isActive: PropTypes.bool,
    isLoading: PropTypes.bool,
    isLoaded: PropTypes.bool,
    profile: PropTypes.object,
  }

  static defaultProps = {
    isLoaded: true
  }

  renderUserComponent = ({ menu: compMenu }) => {
    let {
      defaultMenu,
      menu,

      text,
      avatar,
      listItem,

      ...props
    } = this.props

    if (text) {
      return (
        <TextUser
          {...props}
          menu={compMenu}
        />
      )
    } else if (avatar) {
      return (
        <AvatarUser
          {...props}
          menu={compMenu}
        />
      )
    } else if (listItem) {
      return (
        <ListItemUser
          {...props}
          menu={compMenu}
        />
      )
    } else {
      return null
    }
  }

  render () {
    let {
      defaultMenu,
      menu,

      isLoaded
    } = this.props

    const withMenu = defaultMenu || menu

    return (isLoaded && withMenu) ? (
      <UserMenu
        {...this.props}
      >
        {this.renderUserComponent}
      </UserMenu>
    ) : (
      this.renderUserComponent({ menu: null })
    )
  }
}

export default User

